module.exports = __webpack_public_path__ + "img/fixedimg.19ee0ebe.png";